import axios from "axios";

/**
 * Resolve the backend URL at runtime.
 * - In the browser, if we're on an HTTPS origin, call the same origin (same-origin = no CORS/cookie issues).
 *   This means the app works whether it's served at pipbennett.com, pausewithpip.com.au, or the
 *   underlying emergent.host URL — without needing a frontend rebuild per domain.
 * - Fallback to the build-time REACT_APP_BACKEND_URL (used in dev and for SSR/tests).
 */
function resolveBackendUrl() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
